export const RenderInput = ({ field, onChange = () => {} }) => {
  const valueBool = [
    {
      id: 0,
      label: field?.DEFAULT_TRUE || "true",
      value: true,
    },
    {
      id: 1,
      label: field?.DEFAULT_FALSE || "false",
      value: false,
    },
  ];

  switch (field.DATATYPE) {
    case "TEXT":
      return (
        <input
          type="text"
          className="form-control"
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
          onKeyDown={() => {}}
        />
      );

    case "INT":
    case "INT UNSIGNED":
    case "BIGINT":
    case "BIGINT UNSIGNED":
      return (
        <input
          type={field?.AUTO_INCREMENT ? "text" : "text"}
          className="form-control"
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
          onKeyDown={() => {}}
        />
      );
    case "DATE":
      return (
        <input
          type="date"
          className="form-control"
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
          onKeyDown={() => {}}
        />
      );

    case "DATETIME":
      return (
        <input
          type="date"
          className="form-control"
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
          onKeyDown={() => {}}
        />
      );

    case "BOOL":
      return (
        <select
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
          onKeyDown={() => {}}
          className="form-control"
        >
          <option value="" disabled selected>
            Choose
          </option>
          {valueBool.map((val, index) => (
            <option key={index} value={val.value}>
              {val.label}
            </option>
          ))}
          <option value="">Clear Selection</option>
        </select>
      );

    // Thêm các trường hợp khác tùy theo DATATYPE
    default:
      return (
        <input
          type="text"
          className="form-control"
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
          onKeyDown={() => {}}
        />
      );
  }
};
